// Mock data for Teamwork clone

export const mockUsers = [
  {
    id: '1',
    name: 'Sarah Johnson',
    email: 'sarah@example.com',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    role: 'Project Manager'
  },
  {
    id: '2',
    name: 'Mike Chen',
    email: 'mike@example.com',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    role: 'Developer'
  },
  {
    id: '3',
    name: 'Emily Davis',
    email: 'emily@example.com',
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
    role: 'Designer'
  },
  {
    id: '4',
    name: 'Alex Turner',
    email: 'alex@example.com',
    avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
    role: 'Developer'
  }
];

export const mockCompanies = [
  {
    id: 'comp1',
    name: 'TechCorp Inc.',
    logo: 'https://ui-avatars.com/api/?name=TechCorp&background=6366f1&color=fff',
    industry: 'Technology',
    website: 'https://techcorp.example.com',
    contactEmail: 'contact@techcorp.example.com',
    contactPhone: '+1 (555) 123-4567',
    address: '123 Tech Street, Silicon Valley, CA',
    createdAt: '2024-06-15'
  },
  {
    id: 'comp2',
    name: 'Marketing Pro',
    logo: 'https://ui-avatars.com/api/?name=Marketing+Pro&background=ec4899&color=fff',
    industry: 'Marketing',
    website: 'https://marketingpro.example.com',
    contactEmail: 'hello@marketingpro.example.com',
    contactPhone: '+1 (555) 234-5678',
    address: '456 Marketing Ave, New York, NY',
    createdAt: '2024-08-20'
  },
  {
    id: 'comp3',
    name: 'FinanceHub',
    logo: 'https://ui-avatars.com/api/?name=FinanceHub&background=10b981&color=fff',
    industry: 'Finance',
    website: 'https://financehub.example.com',
    contactEmail: 'support@financehub.example.com',
    contactPhone: '+1 (555) 345-6789',
    address: '789 Finance Blvd, Chicago, IL',
    createdAt: '2024-10-05'
  },
  {
    id: 'comp4',
    name: 'Creative Studios',
    logo: 'https://ui-avatars.com/api/?name=Creative+Studios&background=f59e0b&color=fff',
    industry: 'Design',
    website: 'https://creativestudios.example.com',
    contactEmail: 'info@creativestudios.example.com',
    contactPhone: '+1 (555) 456-7890',
    address: '321 Design Lane, Los Angeles, CA',
    createdAt: '2024-12-01'
  }
];

export const mockCategories = [
  { id: 'cat1', name: 'Development' },
  { id: 'cat2', name: 'Marketing' },
  { id: 'cat3', name: 'Finance' },
  { id: 'cat4', name: 'Operations' },
  { id: 'cat5', name: 'Design' }
];

export const mockProjects = [
  {
    id: '1',
    name: 'Website Redesign',
    description: 'Complete overhaul of company website',
    scopeOfWork: 'Design and develop a modern, responsive website with improved UX, SEO optimization, and integration with CMS',
    deliverables: 'Wireframes, UI designs, fully functional website, documentation, training materials',
    summary: 'Project is progressing well with design phase completed ahead of schedule. Development phase in progress with homepage and key sections being built. Minor delays expected in backend API development but overall timeline remains on track.',
    lastUpdate: 'Development phase 65% complete. Homepage deployed to staging. Working on product catalog integration.',
    lastUpdateDate: '2025-12-18',
    manualStatus: null, // null means auto-calculated, or 'on-hold', 'cancelled', 'completed'
    progress: 65,
    startDate: '2025-01-15',
    endDate: '2025-03-30',
    color: '#10b981',
    categoryId: 'cat1',
    companyId: 'comp1',
    projectManagerId: '1', // Sarah Johnson
    teamMembers: ['1', '2', '3'],
    createdWithAI: false,
    tags: ['web', 'frontend', 'design'],
    isEscalated: false,
    escalatedTo: null,
    escalationReason: null,
    escalationHistory: [],
    isFavorite: true
  },
  {
    id: '2',
    name: 'Mobile App Development',
    description: 'iOS and Android app for customer portal',
    scopeOfWork: 'Build native mobile applications for iOS and Android with user authentication, real-time notifications, and offline capabilities',
    deliverables: 'iOS app, Android app, API integration, app store submissions, user guide',
    summary: 'Project kicked off successfully with requirements finalized. Architecture design is underway with focus on scalability and performance.',
    lastUpdate: 'iOS app beta submitted to TestFlight. Android version in QA testing. Backend API integration 80% complete.',
    lastUpdateDate: '2025-12-01',
    manualStatus: null,
    progress: 40,
    startDate: '2025-02-01',
    endDate: '2025-05-15',
    color: '#3b82f6',
    categoryId: 'cat1',
    companyId: 'comp1',
    projectManagerId: '2', // Mike Chen
    teamMembers: ['2', '4'],
    createdWithAI: true,
    tags: ['mobile', 'ios', 'android'],
    isEscalated: true,
    escalatedTo: '1',
    escalationReason: 'Backend API delays affecting delivery timeline',
    escalationHistory: [
      {
        id: 'esc1',
        escalatedTo: '3',
        reason: 'Initial resource constraints',
        date: '2025-01-20',
        resolvedDate: '2025-01-25',
        resolvedBy: '1'
      }
    ],
    isFavorite: false
  },
  {
    id: '3',
    name: 'Marketing Campaign Q1',
    description: 'Social media and email marketing initiative',
    scopeOfWork: 'Create and execute comprehensive digital marketing strategy across social media, email, and content marketing channels',
    deliverables: 'Campaign strategy, content calendar, 50+ social posts, 12 email campaigns, performance reports',
    summary: 'Campaign execution is exceeding expectations with high engagement rates. 80% of content created and published. Final week push for remaining deliverables.',
    lastUpdate: 'All social media content scheduled through March. Email open rates at 32% (above target). Working on final performance report.',
    lastUpdateDate: '2025-12-20',
    manualStatus: null,
    progress: 80,
    startDate: '2025-01-01',
    endDate: '2025-02-28',
    color: '#f59e0b',
    categoryId: 'cat2',
    companyId: 'comp2',
    projectManagerId: '1', // Sarah Johnson
    teamMembers: ['1', '3'],
    createdWithAI: false,
    tags: ['marketing', 'social'],
    isEscalated: false,
    escalatedTo: null,
    escalationReason: null,
    escalationHistory: [],
    isFavorite: true
  },
  {
    id: '4',
    name: 'Financial Planning System',
    description: 'Implement new financial tracking and reporting system',
    scopeOfWork: 'Deploy enterprise financial planning software with integration to existing ERP systems',
    deliverables: 'System configuration, data migration, custom reports, user training, go-live support',
    summary: 'Project in early stages with vendor selection completed. Initial system configuration and data mapping exercises underway.',
    lastUpdate: 'Waiting for executive budget approval. Vendor contract terms finalized pending signature.',
    lastUpdateDate: '2025-11-25',
    manualStatus: 'on-hold',
    progress: 25,
    startDate: '2025-02-10',
    endDate: '2025-06-30',
    color: '#8b5cf6',
    categoryId: 'cat3',
    companyId: 'comp3',
    projectManagerId: '4', // Alex Turner
    teamMembers: ['1', '2'],
    createdWithAI: true,
    tags: ['finance', 'erp'],
    isEscalated: true,
    escalatedTo: '1',
    escalationReason: 'Budget approval pending from executive team',
    escalationHistory: [
      {
        id: 'esc2',
        escalatedTo: '2',
        reason: 'Vendor negotiations stalled',
        date: '2025-01-15',
        resolvedDate: '2025-01-28',
        resolvedBy: '1'
      }
    ],
    isFavorite: false
  },
  {
    id: '5',
    name: 'Brand Identity Refresh',
    description: 'Update company brand guidelines and assets',
    scopeOfWork: 'Modernize brand identity including logo, color palette, typography, and create comprehensive brand guidelines',
    deliverables: 'Updated logo suite, brand guidelines document, digital assets library, presentation templates',
    summary: 'Logo concepts approved by stakeholders. Currently developing comprehensive brand guidelines and creating digital asset library.',
    lastUpdate: 'Project completed. All deliverables handed over. Brand guidelines document available for download.',
    lastUpdateDate: '2025-12-19',
    manualStatus: 'completed',
    progress: 100,
    startDate: '2025-01-20',
    endDate: '2025-03-15',
    color: '#ec4899',
    categoryId: 'cat5',
    companyId: 'comp4',
    projectManagerId: '3', // Emily Davis
    teamMembers: ['3'],
    createdWithAI: false,
    tags: ['branding', 'design'],
    isEscalated: false,
    escalatedTo: null,
    escalationReason: null,
    escalationHistory: [],
    isFavorite: false
  },
  {
    id: '6',
    name: 'Process Automation Initiative',
    description: 'Automate key operational workflows',
    scopeOfWork: 'Identify, design, and implement automation for repetitive operational tasks using RPA tools',
    deliverables: 'Process analysis report, automation workflows, bot deployments, ROI dashboard',
    summary: 'Discovery phase completed with 12 automation opportunities identified. Prioritization workshop scheduled for next week.',
    lastUpdate: 'Discovery phase completed with 12 automation opportunities identified. Prioritization workshop scheduled for next week.',
    lastUpdateDate: '2025-12-10',
    manualStatus: null,
    progress: 0,
    startDate: '2025-02-15',
    endDate: '2025-05-30',
    color: '#06b6d4',
    categoryId: 'cat4',
    companyId: 'comp1',
    projectManagerId: '2', // Mike Chen
    teamMembers: ['2', '4'],
    createdWithAI: true,
    tags: ['automation', 'rpa'],
    isEscalated: false,
    escalatedTo: null,
    escalationReason: null,
    escalationHistory: [],
    isFavorite: false
  }
];

export const mockTaskLists = [
  {
    id: '1',
    projectId: '1',
    name: 'Design Phase',
    description: 'UI/UX design and prototyping',
    order: 1
  },
  {
    id: '2',
    projectId: '1',
    name: 'Development',
    description: 'Frontend and backend implementation',
    order: 2
  },
  {
    id: '3',
    projectId: '1',
    name: 'Testing & QA',
    description: 'Quality assurance and bug fixes',
    order: 3
  },
  {
    id: '4',
    projectId: '2',
    name: 'Planning',
    description: 'Project planning and requirements',
    order: 1
  },
  {
    id: '5',
    projectId: '2',
    name: 'Development Sprint 1',
    description: 'Core features implementation',
    order: 2
  }
];

export const mockTasks = [
  {
    id: '1',
    taskListId: '1',
    projectId: '1',
    title: 'Create wireframes',
    description: 'Design wireframes for all main pages',
    status: 'completed',
    priority: 'high',
    assigneeId: '3',
    startDate: '2025-01-15',
    dueDate: '2025-01-20',
    estimatedHours: 16,
    loggedHours: 18,
    weight: 10,
    tags: ['design', 'wireframes'],
    dependencies: []
  },
  {
    id: '2',
    taskListId: '1',
    projectId: '1',
    title: 'Design UI mockups',
    description: 'High-fidelity mockups based on wireframes',
    status: 'completed',
    priority: 'high',
    assigneeId: '3',
    startDate: '2025-01-21',
    dueDate: '2025-01-28',
    estimatedHours: 24,
    loggedHours: 22,
    weight: 15,
    tags: ['design', 'ui'],
    dependencies: ['1']
  },
  {
    id: '3',
    taskListId: '1',
    projectId: '1',
    title: 'Create design system',
    description: 'Component library and style guide',
    status: 'in-progress',
    priority: 'medium',
    assigneeId: '3',
    startDate: '2025-01-29',
    dueDate: '2025-02-05',
    estimatedHours: 20,
    loggedHours: 12,
    weight: 12,
    tags: ['design', 'components'],
    dependencies: ['2']
  },
  {
    id: '4',
    taskListId: '2',
    projectId: '1',
    title: 'Setup development environment',
    description: 'Configure repos, CI/CD pipelines',
    status: 'completed',
    priority: 'high',
    assigneeId: '2',
    startDate: '2025-02-01',
    dueDate: '2025-02-03',
    estimatedHours: 8,
    loggedHours: 6,
    weight: 8,
    tags: ['setup', 'devops'],
    dependencies: []
  },
  {
    id: '5',
    taskListId: '2',
    projectId: '1',
    title: 'Build homepage',
    description: 'Implement homepage components and layout',
    status: 'in-progress',
    priority: 'high',
    assigneeId: '2',
    startDate: '2025-02-06',
    dueDate: '2025-02-12',
    estimatedHours: 16,
    loggedHours: 8,
    weight: 15,
    tags: ['frontend', 'homepage'],
    dependencies: ['3', '4']
  },
  {
    id: '6',
    taskListId: '2',
    projectId: '1',
    title: 'Build product pages',
    description: 'Product listing and detail pages',
    status: 'todo',
    priority: 'medium',
    assigneeId: '2',
    startDate: '2025-02-13',
    dueDate: '2025-02-20',
    estimatedHours: 20,
    loggedHours: 0,
    weight: 12,
    tags: ['frontend', 'products'],
    dependencies: ['5']
  },
  {
    id: '7',
    taskListId: '2',
    projectId: '1',
    title: 'Backend API development',
    description: 'RESTful API for all features',
    status: 'in-progress',
    priority: 'high',
    assigneeId: '4',
    startDate: '2025-02-06',
    dueDate: '2025-02-25',
    estimatedHours: 40,
    loggedHours: 15,
    weight: 20,
    tags: ['backend', 'api'],
    dependencies: ['4']
  },
  {
    id: '8',
    taskListId: '3',
    projectId: '1',
    title: 'Unit testing',
    description: 'Write unit tests for all components',
    status: 'todo',
    priority: 'medium',
    assigneeId: '2',
    startDate: '2025-02-26',
    dueDate: '2025-03-05',
    estimatedHours: 16,
    loggedHours: 0,
    weight: 6,
    tags: ['testing', 'unit'],
    dependencies: ['6', '7']
  },
  {
    id: '9',
    taskListId: '3',
    projectId: '1',
    title: 'Integration testing',
    description: 'End-to-end testing scenarios',
    status: 'todo',
    priority: 'high',
    assigneeId: '4',
    startDate: '2025-03-06',
    dueDate: '2025-03-15',
    estimatedHours: 20,
    loggedHours: 0,
    weight: 8,
    tags: ['testing', 'e2e'],
    dependencies: ['8']
  },
  {
    id: '10',
    taskListId: '4',
    projectId: '2',
    title: 'Requirements gathering',
    description: 'Collect and document requirements',
    status: 'completed',
    priority: 'high',
    assigneeId: '1',
    startDate: '2025-02-01',
    dueDate: '2025-02-05',
    estimatedHours: 12,
    loggedHours: 14,
    weight: 10,
    tags: ['planning'],
    dependencies: []
  },
  {
    id: '11',
    taskListId: '4',
    projectId: '2',
    title: 'Technical architecture',
    description: 'Design system architecture',
    status: 'in-progress',
    priority: 'high',
    assigneeId: '2',
    startDate: '2025-02-06',
    dueDate: '2025-02-12',
    estimatedHours: 16,
    loggedHours: 10,
    weight: 15,
    tags: ['planning', 'architecture'],
    dependencies: ['10']
  }
];

export const mockComments = [
  {
    id: '1',
    taskId: '3',
    userId: '1',
    content: 'Great progress on the design system! Can we add dark mode support?',
    createdAt: '2025-02-01T10:30:00Z',
    attachments: []
  },
  {
    id: '2',
    taskId: '3',
    userId: '3',
    content: 'Absolutely! I\'ll include dark mode variants for all components.',
    createdAt: '2025-02-01T11:15:00Z',
    attachments: []
  },
  {
    id: '3',
    taskId: '5',
    userId: '2',
    content: 'Homepage is taking shape nicely. Added hero section and features.',
    createdAt: '2025-02-08T14:20:00Z',
    attachments: [
      { id: 'f1', name: 'homepage-preview.png', url: '#', type: 'image/png', size: 245000, uploadedAt: '2025-02-08T14:20:00Z' }
    ]
  },
  {
    id: '4',
    taskId: '7',
    userId: '4',
    content: 'API endpoints for user auth and products are ready for testing.',
    createdAt: '2025-02-10T09:45:00Z',
    attachments: [
      { id: 'f2', name: 'api-documentation.pdf', url: '#', type: 'application/pdf', size: 1250000, uploadedAt: '2025-02-10T09:45:00Z' }
    ]
  },
  {
    id: '5',
    taskId: '3',
    userId: '3',
    content: 'Design system documentation and component library files attached.',
    createdAt: '2025-02-03T16:30:00Z',
    attachments: [
      { id: 'f3', name: 'design-system-guide.pdf', url: '#', type: 'application/pdf', size: 3450000, uploadedAt: '2025-02-03T16:30:00Z' },
      { id: 'f4', name: 'component-library.zip', url: '#', type: 'application/zip', size: 8920000, uploadedAt: '2025-02-03T16:30:00Z' }
    ]
  }
];

export const mockProjectFiles = [
  {
    id: 'charter-1',
    projectId: '1',
    name: 'Project Charter - Website Redesign.pdf',
    type: 'application/pdf',
    size: 450000,
    uploadedBy: '1',
    uploadedAt: '2025-01-15T09:00:00Z',
    category: 'charter',
    url: '#'
  },
  {
    id: 'f1',
    projectId: '1',
    taskId: '5',
    commentId: '3',
    name: 'homepage-preview.png',
    type: 'image/png',
    size: 245000,
    uploadedBy: '2',
    uploadedAt: '2025-02-08T14:20:00Z',
    category: 'task-attachment',
    url: '#'
  },
  {
    id: 'f2',
    projectId: '1',
    taskId: '7',
    commentId: '4',
    name: 'api-documentation.pdf',
    type: 'application/pdf',
    size: 1250000,
    uploadedBy: '4',
    uploadedAt: '2025-02-10T09:45:00Z',
    category: 'task-attachment',
    url: '#'
  },
  {
    id: 'f3',
    projectId: '1',
    taskId: '3',
    commentId: '5',
    name: 'design-system-guide.pdf',
    type: 'application/pdf',
    size: 3450000,
    uploadedBy: '3',
    uploadedAt: '2025-02-03T16:30:00Z',
    category: 'task-attachment',
    url: '#'
  },
  {
    id: 'f4',
    projectId: '1',
    taskId: '3',
    commentId: '5',
    name: 'component-library.zip',
    type: 'application/zip',
    size: 8920000,
    uploadedBy: '3',
    uploadedAt: '2025-02-03T16:30:00Z',
    category: 'task-attachment',
    url: '#'
  }
];

export const mockMilestones = [
  {
    id: '1',
    projectId: '1',
    name: 'Design Complete',
    date: '2025-02-05',
    status: 'completed'
  },
  {
    id: '2',
    projectId: '1',
    name: 'Development Complete',
    date: '2025-02-25',
    status: 'upcoming'
  },
  {
    id: '3',
    projectId: '1',
    name: 'Launch Ready',
    date: '2025-03-30',
    status: 'upcoming'
  }
];

export const mockTimeEntries = [
  {
    id: '1',
    taskId: '3',
    userId: '3',
    hours: 4,
    date: '2025-02-01',
    description: 'Working on button components'
  },
  {
    id: '2',
    taskId: '3',
    userId: '3',
    hours: 4,
    date: '2025-02-02',
    description: 'Form components and inputs'
  },
  {
    id: '3',
    taskId: '5',
    userId: '2',
    hours: 6,
    date: '2025-02-08',
    description: 'Hero section implementation'
  },
  {
    id: '4',
    taskId: '7',
    userId: '4',
    hours: 8,
    date: '2025-02-09',
    description: 'User authentication endpoints'
  }
];


// Meeting Types / Committees for Action Items
export const mockCommittees = [
  { id: 'board', name: 'Board Meeting', shortCode: 'BOARD', count: 12 },
  { id: 'excomm', name: 'Executive Committee', shortCode: 'EXCOMM', count: 24 },
  { id: 'ops', name: 'Operations Review', shortCode: 'OPS', count: 18 },
  { id: 'finance', name: 'Finance Committee', shortCode: 'FIN', count: 8 },
  { id: 'hr', name: 'HR Committee', shortCode: 'HR', count: 6 },
  { id: 'tech', name: 'Technology Review', shortCode: 'TECH', count: 10 }
];

// Meetings (MOM - Minutes of Meeting)
export const mockMeetings = [
  { 
    id: 'BOARD-001', 
    committeeId: 'board', 
    date: '2025-12-15', 
    title: 'Q4 Board Meeting',
    momFile: null,
    momFileName: null
  },
  { 
    id: 'EXCOMM-012', 
    committeeId: 'excomm', 
    date: '2025-11-20', 
    title: 'November Executive Committee',
    momFile: null,
    momFileName: 'EXCOMM_Nov2025.pdf'
  },
  { 
    id: 'OPS-008', 
    committeeId: 'ops', 
    date: '2025-10-10', 
    title: 'October Operations Review',
    momFile: null,
    momFileName: null
  },
  { 
    id: 'FIN-003', 
    committeeId: 'finance', 
    date: '2025-09-25', 
    title: 'Q3 Finance Review',
    momFile: null,
    momFileName: 'Finance_Q3.pdf'
  },
  { 
    id: 'TECH-005', 
    committeeId: 'tech', 
    date: '2025-08-18', 
    title: 'Technology Roadmap Review',
    momFile: null,
    momFileName: null
  }
];

// Action Items
export const mockActionItems = [
  {
    id: 'ai-1',
    meetingId: 'BOARD-001',
    description: 'Review and finalize the annual budget proposal for the upcoming fiscal year.',
    assignedTo: '1',
    status: 'in-progress',
    currentUpdate: 'Draft budget completed. Awaiting final review from department heads before submission.',
    updateDate: '2025-12-10',
    escalatedTo: null,
    escalationReason: null,
    escalatedBy: null,
    dueDate: '2025-12-20',
    createdAt: '2025-12-15',
    updates: [
      {
        id: 'upd-1-1',
        date: '2025-12-08',
        text: 'Initial draft prepared based on department submissions.',
        userId: '1',
        documents: ['budget_draft_v1.xlsx']
      },
      {
        id: 'upd-1-2',
        date: '2025-12-10',
        text: 'Draft budget completed. Awaiting final review from department heads before submission.',
        userId: '1',
        documents: []
      }
    ]
  },
  {
    id: 'ai-2',
    meetingId: 'BOARD-001',
    description: 'Prepare presentation on market expansion strategy for the board.',
    assignedTo: '2',
    status: 'late',
    currentUpdate: 'Research phase extended due to additional market analysis requirements.',
    updateDate: '2025-12-12',
    escalatedTo: '1',
    escalationReason: 'Deadline missed, needs executive attention',
    escalatedBy: '3',
    dueDate: '2025-12-10',
    createdAt: '2025-12-15',
    updates: [
      {
        id: 'upd-2-1',
        date: '2025-12-12',
        text: 'Research phase extended due to additional market analysis requirements.',
        userId: '2',
        documents: []
      }
    ]
  },
  {
    id: 'ai-3',
    meetingId: 'EXCOMM-012',
    description: 'Complete the quarterly performance review for all departments.',
    assignedTo: '3',
    status: 'completed',
    currentUpdate: 'All reviews completed and submitted to HR.',
    updateDate: '2025-11-28',
    escalatedTo: null,
    escalationReason: null,
    escalatedBy: null,
    dueDate: '2025-11-30',
    createdAt: '2025-11-20',
    updates: [
      {
        id: 'upd-3-1',
        date: '2025-11-25',
        text: 'Reviews for Sales and Marketing completed.',
        userId: '3',
        documents: ['sales_review.pdf', 'marketing_review.pdf']
      },
      {
        id: 'upd-3-2',
        date: '2025-11-28',
        text: 'All reviews completed and submitted to HR.',
        userId: '3',
        documents: ['final_reviews.pdf']
      }
    ]
  },
  {
    id: 'ai-4',
    meetingId: 'EXCOMM-012',
    description: 'Coordinate with IT team to implement new security protocols.',
    assignedTo: '4',
    status: 'in-progress',
    currentUpdate: 'Security audit in progress. Expected completion by end of week.',
    updateDate: '2025-12-05',
    escalatedTo: null,
    escalationReason: null,
    escalatedBy: null,
    dueDate: '2025-12-15',
    createdAt: '2025-11-20',
    updates: [
      {
        id: 'upd-4-1',
        date: '2025-12-01',
        text: 'Initial security assessment completed.',
        userId: '4',
        documents: ['security_assessment.pdf']
      },
      {
        id: 'upd-4-2',
        date: '2025-12-05',
        text: 'Security audit in progress. Expected completion by end of week.',
        userId: '4',
        documents: []
      }
    ]
  },
  {
    id: 'ai-5',
    meetingId: 'OPS-008',
    description: 'Optimize warehouse inventory management system.',
    assignedTo: '1',
    status: 'late',
    currentUpdate: 'Vendor negotiations ongoing. New system demo scheduled for next week.',
    updateDate: '2025-11-15',
    escalatedTo: '2',
    escalationReason: 'Project delayed beyond original timeline',
    escalatedBy: '4',
    dueDate: '2025-10-30',
    createdAt: '2025-10-10',
    updates: [
      {
        id: 'upd-5-1',
        date: '2025-10-20',
        text: 'Requirements gathered from warehouse team.',
        userId: '1',
        documents: []
      },
      {
        id: 'upd-5-2',
        date: '2025-11-15',
        text: 'Vendor negotiations ongoing. New system demo scheduled for next week.',
        userId: '1',
        documents: ['vendor_comparison.xlsx']
      }
    ]
  },
  {
    id: 'ai-6',
    meetingId: 'FIN-003',
    description: 'Prepare cost analysis report for new product line.',
    assignedTo: '2',
    status: 'completed',
    currentUpdate: 'Report finalized and presented to finance committee.',
    updateDate: '2025-10-05',
    escalatedTo: null,
    escalationReason: null,
    escalatedBy: null,
    dueDate: '2025-10-10',
    createdAt: '2025-09-25',
    updates: [
      {
        id: 'upd-6-1',
        date: '2025-10-05',
        text: 'Report finalized and presented to finance committee.',
        userId: '2',
        documents: ['cost_analysis_final.pdf', 'presentation.pptx']
      }
    ]
  },
  {
    id: 'ai-7',
    meetingId: 'TECH-005',
    description: 'Evaluate cloud migration options and prepare recommendation.',
    assignedTo: '4',
    status: 'in-progress',
    currentUpdate: 'Completed AWS and Azure evaluations. Preparing final recommendation document.',
    updateDate: '2025-09-20',
    escalatedTo: null,
    escalationReason: null,
    escalatedBy: null,
    dueDate: '2025-09-30',
    createdAt: '2025-08-18',
    updates: [
      {
        id: 'upd-7-1',
        date: '2025-09-10',
        text: 'AWS evaluation completed.',
        userId: '4',
        documents: ['aws_evaluation.pdf']
      },
      {
        id: 'upd-7-2',
        date: '2025-09-20',
        text: 'Completed AWS and Azure evaluations. Preparing final recommendation document.',
        userId: '4',
        documents: ['azure_evaluation.pdf']
      }
    ]
  },
  {
    id: 'ai-8',
    meetingId: 'TECH-005',
    description: 'Update company website with new branding guidelines.',
    assignedTo: '3',
    status: 'on-hold',
    currentUpdate: 'Waiting for final brand assets from marketing team.',
    updateDate: '2025-09-15',
    escalatedTo: null,
    escalationReason: null,
    escalatedBy: null,
    dueDate: '2025-10-01',
    createdAt: '2025-08-18',
    updates: [
      {
        id: 'upd-8-1',
        date: '2025-09-15',
        text: 'Waiting for final brand assets from marketing team.',
        userId: '3',
        documents: []
      }
    ]
  }
];


// Lists for Action Items (Chairman, CEO, Company-specific)
export const mockLists = [
  { id: 'chairman', name: 'Chairman Action Items', type: 'list' },
  { id: 'ceo', name: 'CEO Action Items', type: 'list' },
  { id: 'techcorp', name: 'TechCorp Inc. Action Items', type: 'list' }
];

// List-based Action Items (tied to people/companies, not meetings)
export const mockListActionItems = [
  {
    id: 'list-1',
    listId: 'chairman',
    itemType: 'list',
    description: 'Review and approve the annual strategic plan for 2026.',
    assignedTo: '1',
    dueDate: '2025-12-30',
    status: 'in-progress',
    currentUpdate: 'Initial draft received from strategy team. Reviewing key initiatives.',
    createdAt: '2025-12-01',
    updates: [
      {
        id: 'u1',
        date: '2025-12-10',
        content: 'Initial draft received from strategy team. Reviewing key initiatives.',
        userId: '1',
        documents: []
      }
    ],
    escalatedTo: null,
    escalatedBy: null,
    escalationReason: null
  },
  {
    id: 'list-2',
    listId: 'chairman',
    itemType: 'list',
    description: 'Schedule meeting with board members regarding Q1 2026 objectives.',
    assignedTo: '2',
    dueDate: '2025-12-20',
    status: 'completed',
    currentUpdate: 'Meeting scheduled for January 5th, 2026. All board members confirmed.',
    createdAt: '2025-11-15',
    updates: [
      {
        id: 'u2',
        date: '2025-12-15',
        content: 'Meeting scheduled for January 5th, 2026. All board members confirmed.',
        userId: '2',
        documents: []
      }
    ],
    escalatedTo: null,
    escalatedBy: null,
    escalationReason: null
  },
  {
    id: 'list-3',
    listId: 'ceo',
    itemType: 'list',
    description: 'Finalize budget allocation for new product development initiative.',
    assignedTo: '1',
    dueDate: '2025-12-25',
    status: 'in-progress',
    currentUpdate: 'Working with finance team to optimize resource allocation.',
    createdAt: '2025-12-05',
    updates: [
      {
        id: 'u3',
        date: '2025-12-12',
        content: 'Working with finance team to optimize resource allocation.',
        userId: '1',
        documents: []
      }
    ],
    escalatedTo: '1',
    escalatedBy: '3',
    escalationReason: 'Budget deadline approaching, need executive approval'
  },
  {
    id: 'list-4',
    listId: 'ceo',
    itemType: 'list',
    description: 'Prepare presentation for investor meeting on company growth metrics.',
    assignedTo: '3',
    dueDate: '2026-01-10',
    status: 'in-progress',
    currentUpdate: 'Gathering data from all departments. Presentation outline ready.',
    createdAt: '2025-12-08',
    updates: [
      {
        id: 'u4',
        date: '2025-12-14',
        content: 'Gathering data from all departments. Presentation outline ready.',
        userId: '3',
        documents: []
      }
    ],
    escalatedTo: null,
    escalatedBy: null,
    escalationReason: null
  },
  {
    id: 'list-5',
    listId: 'ceo',
    itemType: 'list',
    description: 'Review and sign off on new employee compensation structure.',
    assignedTo: '2',
    dueDate: '2025-12-18',
    status: 'late',
    currentUpdate: 'HR team revising proposal based on market analysis feedback.',
    createdAt: '2025-11-20',
    updates: [
      {
        id: 'u5',
        date: '2025-12-10',
        content: 'HR team revising proposal based on market analysis feedback.',
        userId: '2',
        documents: []
      }
    ],
    escalatedTo: '1',
    escalatedBy: '2',
    escalationReason: 'Delayed due to additional market research requirements'
  },
  {
    id: 'list-6',
    listId: 'techcorp',
    itemType: 'list',
    description: 'Complete due diligence report for TechCorp Inc. acquisition review.',
    assignedTo: '4',
    dueDate: '2025-12-28',
    status: 'in-progress',
    currentUpdate: 'Financial analysis complete. Awaiting legal team review.',
    createdAt: '2025-12-01',
    updates: [
      {
        id: 'u6',
        date: '2025-12-11',
        content: 'Financial analysis complete. Awaiting legal team review.',
        userId: '4',
        documents: [{ name: 'Financial_Analysis_TechCorp.pdf', url: '#' }]
      }
    ],
    escalatedTo: null,
    escalatedBy: null,
    escalationReason: null
  },
  {
    id: 'list-7',
    listId: 'techcorp',
    itemType: 'list',
    description: 'Coordinate integration planning with TechCorp Inc. leadership team.',
    assignedTo: '1',
    dueDate: '2026-01-15',
    status: 'on-hold',
    currentUpdate: 'Waiting for due diligence completion before proceeding.',
    createdAt: '2025-12-05',
    updates: [
      {
        id: 'u7',
        date: '2025-12-08',
        content: 'Waiting for due diligence completion before proceeding.',
        userId: '1',
        documents: []
      }
    ],
    escalatedTo: null,
    escalatedBy: null,
    escalationReason: null
  }
];

// ==========================================
// MEETING MANAGEMENT MODULE DATA
// ==========================================

// Meeting Statuses
export const meetingStatuses = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in-progress',
  PENDING_REVIEW: 'pending-review',
  APPROVED: 'approved',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

// Meeting Templates (pre-built agendas)
export const mockMeetingTemplates = [
  {
    id: 'template-1',
    name: 'Board Meeting Standard',
    committeeId: 'board',
    duration: 120,
    agendaItems: [
      { title: 'Call to Order & Roll Call', duration: 5, presenter: null },
      { title: 'Approval of Previous Minutes', duration: 10, presenter: null },
      { title: 'CEO Report', duration: 20, presenter: 'CEO' },
      { title: 'CFO Financial Update', duration: 20, presenter: 'CFO' },
      { title: 'Strategic Initiatives Review', duration: 30, presenter: null },
      { title: 'New Business', duration: 20, presenter: null },
      { title: 'Action Items Review', duration: 10, presenter: null },
      { title: 'Adjournment', duration: 5, presenter: null }
    ]
  },
  {
    id: 'template-2',
    name: 'Executive Committee Weekly',
    committeeId: 'excomm',
    duration: 60,
    agendaItems: [
      { title: 'Opening & Attendance', duration: 5, presenter: null },
      { title: 'Previous Action Items Follow-up', duration: 15, presenter: null },
      { title: 'Department Updates', duration: 20, presenter: null },
      { title: 'Key Decisions Required', duration: 15, presenter: null },
      { title: 'New Action Items', duration: 5, presenter: null }
    ]
  },
  {
    id: 'template-3',
    name: 'Operations Review',
    committeeId: 'ops',
    duration: 90,
    agendaItems: [
      { title: 'Safety & Compliance Update', duration: 10, presenter: 'Safety Officer' },
      { title: 'Operational KPIs Review', duration: 20, presenter: 'Operations Manager' },
      { title: 'Project Status Updates', duration: 25, presenter: null },
      { title: 'Resource Allocation', duration: 15, presenter: null },
      { title: 'Process Improvements', duration: 15, presenter: null },
      { title: 'Action Items & Next Steps', duration: 5, presenter: null }
    ]
  }
];

// Scheduled Meetings
export const mockScheduledMeetings = [
  {
    id: 'meeting-1',
    title: 'Q4 Board Meeting',
    committeeId: 'board',
    templateId: 'template-1',
    date: '2025-12-20',
    startTime: '09:00',
    endTime: '11:00',
    duration: 120,
    location: 'Board Room A',
    videoLink: 'https://zoom.us/j/123456789',
    videoProvider: 'zoom',
    status: 'scheduled',
    isRecurring: false,
    recurringPattern: null,
    organizer: '1',
    agenda: [
      { id: 'ai-1', title: 'Call to Order & Roll Call', duration: 5, presenter: null, status: 'pending', notes: '' },
      { id: 'ai-2', title: 'Approval of Q3 Minutes', duration: 10, presenter: null, status: 'pending', notes: '' },
      { id: 'ai-3', title: 'CEO Annual Report', duration: 25, presenter: '1', status: 'pending', notes: '' },
      { id: 'ai-4', title: 'CFO Financial Review', duration: 25, presenter: '2', status: 'pending', notes: '' },
      { id: 'ai-5', title: '2026 Strategic Plan', duration: 30, presenter: '1', status: 'pending', notes: '' },
      { id: 'ai-6', title: 'New Business & Resolutions', duration: 20, presenter: null, status: 'pending', notes: '' },
      { id: 'ai-7', title: 'Adjournment', duration: 5, presenter: null, status: 'pending', notes: '' }
    ],
    attendees: [
      { id: 'att-1', odId: '1', name: 'Sarah Johnson', email: 'sarah@example.com', role: 'Chair', rsvp: 'accepted', hasApproved: false, isExternal: false },
      { id: 'att-2', odId: '2', name: 'Mike Chen', email: 'mike@example.com', role: 'Secretary', rsvp: 'accepted', hasApproved: false, isExternal: false },
      { id: 'att-3', odId: '3', name: 'Emily Davis', email: 'emily@example.com', role: 'Member', rsvp: 'pending', hasApproved: false, isExternal: false },
      { id: 'att-4', odId: null, name: 'John External', email: 'john@external.com', role: 'Guest', rsvp: 'accepted', hasApproved: false, isExternal: true }
    ],
    mom: null,
    actions: [],
    approvals: [],
    createdAt: '2025-12-01',
    updatedAt: '2025-12-10'
  },
  {
    id: 'meeting-2',
    title: 'Weekly Executive Sync',
    committeeId: 'excomm',
    templateId: 'template-2',
    date: '2025-12-16',
    startTime: '14:00',
    endTime: '15:00',
    duration: 60,
    location: 'Conference Room B',
    videoLink: 'https://teams.microsoft.com/l/meetup-join/abc123',
    videoProvider: 'teams',
    status: 'pending-review',
    isRecurring: true,
    recurringPattern: { frequency: 'weekly', day: 'monday', endDate: '2026-03-31' },
    organizer: '1',
    agenda: [
      { id: 'ai-8', title: 'Opening & Attendance', duration: 5, presenter: null, status: 'discussed', notes: 'All present except Alex (on leave)' },
      { id: 'ai-9', title: 'Previous Action Items', duration: 15, presenter: null, status: 'discussed', notes: '3 of 5 items completed' },
      { id: 'ai-10', title: 'Department Updates', duration: 20, presenter: null, status: 'discussed', notes: 'Marketing launched new campaign. Dev team on track for Q4 release.' },
      { id: 'ai-11', title: 'Budget Reallocation Decision', duration: 15, presenter: '2', status: 'discussed', notes: 'Approved $50K shift from travel to training budget' },
      { id: 'ai-12', title: 'New Action Items', duration: 5, presenter: null, status: 'discussed', notes: '4 new actions assigned' }
    ],
    attendees: [
      { id: 'att-5', odId: '1', name: 'Sarah Johnson', email: 'sarah@example.com', role: 'Chair', rsvp: 'accepted', hasApproved: true, isExternal: false },
      { id: 'att-6', odId: '2', name: 'Mike Chen', email: 'mike@example.com', role: 'Member', rsvp: 'accepted', hasApproved: false, isExternal: false },
      { id: 'att-7', odId: '3', name: 'Emily Davis', email: 'emily@example.com', role: 'Member', rsvp: 'accepted', hasApproved: true, isExternal: false }
    ],
    mom: {
      id: 'mom-1',
      content: 'Meeting called to order at 2:00 PM. All executives present except Alex Turner (on approved leave).\n\n**Action Items Review:**\n- Budget proposal: COMPLETED\n- Hiring plan: IN PROGRESS\n- System upgrade: COMPLETED\n\n**Key Decisions:**\n1. Approved budget reallocation of $50,000 from travel to training\n2. Agreed to postpone office renovation to Q2 2026\n\n**Next Steps:**\n- Sarah to finalize training schedule by Dec 20\n- Mike to prepare Q4 financial close report',
      generatedAt: '2025-12-16T15:05:00Z',
      generatedBy: 'ai',
      approvedBy: [],
      status: 'pending'
    },
    actions: [
      { id: 'ma-1', description: 'Finalize Q1 training schedule', assignedTo: '1', dueDate: '2025-12-20', status: 'pending', linkedActionItemId: null },
      { id: 'ma-2', description: 'Prepare Q4 financial close report', assignedTo: '2', dueDate: '2025-12-22', status: 'pending', linkedActionItemId: null },
      { id: 'ma-3', description: 'Review vendor contracts for renewal', assignedTo: '3', dueDate: '2025-12-30', status: 'pending', linkedActionItemId: null },
      { id: 'ma-4', description: 'Schedule team building event for January', assignedTo: '4', dueDate: '2026-01-05', status: 'pending', linkedActionItemId: null }
    ],
    approvals: [
      { odId: '1', odname: 'Sarah Johnson', approved: true, approvedAt: '2025-12-16T16:00:00Z', comments: '' },
      { odId: '3', odname: 'Emily Davis', approved: true, approvedAt: '2025-12-16T17:30:00Z', comments: 'LGTM' }
    ],
    createdAt: '2025-12-09',
    updatedAt: '2025-12-16'
  },
  {
    id: 'meeting-3',
    title: 'Operations Monthly Review',
    committeeId: 'ops',
    templateId: 'template-3',
    date: '2025-12-18',
    startTime: '10:00',
    endTime: '11:30',
    duration: 90,
    location: 'Operations Center',
    videoLink: 'https://zoom.us/j/987654321',
    videoProvider: 'zoom',
    status: 'approved',
    isRecurring: true,
    recurringPattern: { frequency: 'monthly', day: 18, endDate: '2026-12-31' },
    organizer: '4',
    agenda: [
      { id: 'ai-13', title: 'Safety Update', duration: 10, presenter: '4', status: 'discussed', notes: 'Zero incidents this month. New safety training completed.' },
      { id: 'ai-14', title: 'KPIs Review', duration: 20, presenter: '4', status: 'discussed', notes: 'All KPIs on track. Efficiency improved by 12%.' },
      { id: 'ai-15', title: 'Project Updates', duration: 25, presenter: null, status: 'discussed', notes: 'Warehouse expansion 80% complete. New system rollout on schedule.' },
      { id: 'ai-16', title: 'Resource Planning', duration: 15, presenter: '1', status: 'discussed', notes: 'Approved hiring 3 additional staff for Q1.' },
      { id: 'ai-17', title: 'Process Improvements', duration: 15, presenter: '3', status: 'discussed', notes: 'Implemented new inventory system. 25% reduction in processing time.' },
      { id: 'ai-18', title: 'Action Items', duration: 5, presenter: null, status: 'discussed', notes: '5 actions captured' }
    ],
    attendees: [
      { id: 'att-8', odId: '4', name: 'Alex Turner', email: 'alex@example.com', role: 'Chair', rsvp: 'accepted', hasApproved: true, isExternal: false },
      { id: 'att-9', odId: '1', name: 'Sarah Johnson', email: 'sarah@example.com', role: 'Member', rsvp: 'accepted', hasApproved: true, isExternal: false },
      { id: 'att-10', odId: '3', name: 'Emily Davis', email: 'emily@example.com', role: 'Member', rsvp: 'accepted', hasApproved: true, isExternal: false },
      { id: 'att-11', odId: null, name: 'Tom Contractor', email: 'tom@contractor.com', role: 'Consultant', rsvp: 'accepted', hasApproved: false, isExternal: true }
    ],
    mom: {
      id: 'mom-2',
      content: '**Operations Monthly Review - December 2025**\n\nMeeting commenced at 10:00 AM with all attendees present.\n\n**1. Safety Update**\nZero safety incidents reported. All staff completed mandatory safety training. New PPE distributed.\n\n**2. KPI Performance**\n- Efficiency: 94% (target: 90%) ✅\n- Quality: 98.5% (target: 95%) ✅\n- Delivery: 96% (target: 95%) ✅\n\n**3. Project Status**\n- Warehouse Expansion: 80% complete, on budget\n- System Rollout: Testing phase, go-live Jan 15\n\n**4. Decisions Made**\n- Approved Q1 hiring plan (3 positions)\n- Approved overtime budget for holiday season\n\n**5. Action Items**\nSee attached action items list.',
      generatedAt: '2025-12-18T11:35:00Z',
      generatedBy: 'ai',
      approvedBy: ['4', '1', '3'],
      status: 'approved'
    },
    actions: [
      { id: 'ma-5', description: 'Complete warehouse expansion punch list', assignedTo: '4', dueDate: '2025-12-25', status: 'in-progress', linkedActionItemId: 'ai-3' },
      { id: 'ma-6', description: 'Finalize Q1 hiring job descriptions', assignedTo: '1', dueDate: '2025-12-20', status: 'completed', linkedActionItemId: null },
      { id: 'ma-7', description: 'Prepare system rollout communication plan', assignedTo: '3', dueDate: '2026-01-10', status: 'pending', linkedActionItemId: null }
    ],
    approvals: [
      { odId: '4', odname: 'Alex Turner', approved: true, approvedAt: '2025-12-18T12:00:00Z', comments: '' },
      { odId: '1', odname: 'Sarah Johnson', approved: true, approvedAt: '2025-12-18T14:00:00Z', comments: 'Approved' },
      { odId: '3', odname: 'Emily Davis', approved: true, approvedAt: '2025-12-18T15:30:00Z', comments: '' }
    ],
    createdAt: '2025-12-01',
    updatedAt: '2025-12-18'
  },
  {
    id: 'meeting-4',
    title: 'Finance Committee Q4 Review',
    committeeId: 'fin',
    templateId: null,
    date: '2025-12-22',
    startTime: '11:00',
    endTime: '12:30',
    duration: 90,
    location: 'Finance Conference Room',
    videoLink: null,
    videoProvider: null,
    status: 'draft',
    isRecurring: false,
    recurringPattern: null,
    organizer: '2',
    agenda: [
      { id: 'ai-19', title: 'Q4 Financial Results Preview', duration: 30, presenter: '2', status: 'pending', notes: '' },
      { id: 'ai-20', title: 'Budget vs Actual Analysis', duration: 20, presenter: '2', status: 'pending', notes: '' },
      { id: 'ai-21', title: '2026 Budget Discussion', duration: 30, presenter: '1', status: 'pending', notes: '' },
      { id: 'ai-22', title: 'Audit Preparation Update', duration: 10, presenter: '2', status: 'pending', notes: '' }
    ],
    attendees: [
      { id: 'att-12', odId: '2', name: 'Mike Chen', email: 'mike@example.com', role: 'Chair', rsvp: 'pending', hasApproved: false, isExternal: false },
      { id: 'att-13', odId: '1', name: 'Sarah Johnson', email: 'sarah@example.com', role: 'Member', rsvp: 'pending', hasApproved: false, isExternal: false }
    ],
    mom: null,
    actions: [],
    approvals: [],
    createdAt: '2025-12-15',
    updatedAt: '2025-12-15'
  },
  {
    id: 'meeting-5',
    title: 'Emergency HR Meeting',
    committeeId: 'hr',
    templateId: null,
    date: '2025-12-14',
    startTime: '15:00',
    endTime: '16:00',
    duration: 60,
    location: 'HR Office',
    videoLink: 'https://teams.microsoft.com/l/meetup-join/xyz789',
    videoProvider: 'teams',
    status: 'completed',
    isRecurring: false,
    recurringPattern: null,
    organizer: '3',
    agenda: [
      { id: 'ai-23', title: 'Policy Update Discussion', duration: 20, presenter: '3', status: 'discussed', notes: 'Updated remote work policy reviewed' },
      { id: 'ai-24', title: 'Benefits Enrollment Deadline', duration: 20, presenter: '3', status: 'discussed', notes: 'Extended deadline to Dec 31' },
      { id: 'ai-25', title: 'Year-End Reviews Schedule', duration: 20, presenter: '1', status: 'discussed', notes: 'Reviews to be completed by Dec 20' }
    ],
    attendees: [
      { id: 'att-14', odId: '3', name: 'Emily Davis', email: 'emily@example.com', role: 'Chair', rsvp: 'accepted', hasApproved: true, isExternal: false },
      { id: 'att-15', odId: '1', name: 'Sarah Johnson', email: 'sarah@example.com', role: 'Member', rsvp: 'accepted', hasApproved: true, isExternal: false },
      { id: 'att-16', odId: '2', name: 'Mike Chen', email: 'mike@example.com', role: 'Member', rsvp: 'accepted', hasApproved: true, isExternal: false }
    ],
    mom: {
      id: 'mom-3',
      content: '**Emergency HR Meeting - December 14, 2025**\n\n**Attendees:** Emily Davis (Chair), Sarah Johnson, Mike Chen\n\n**1. Remote Work Policy**\nUpdated policy approved. Employees may work remotely up to 3 days per week starting January 2026.\n\n**2. Benefits Enrollment**\nDeadline extended to December 31, 2025. HR to send reminder emails.\n\n**3. Year-End Reviews**\nAll reviews must be submitted by December 20. Managers reminded via email.\n\n**Meeting adjourned at 4:00 PM.**',
      generatedAt: '2025-12-14T16:05:00Z',
      generatedBy: 'manual',
      approvedBy: ['3', '1', '2'],
      status: 'approved'
    },
    actions: [
      { id: 'ma-8', description: 'Send benefits enrollment reminder', assignedTo: '3', dueDate: '2025-12-16', status: 'completed', linkedActionItemId: null },
      { id: 'ma-9', description: 'Publish updated remote work policy', assignedTo: '3', dueDate: '2025-12-18', status: 'completed', linkedActionItemId: null }
    ],
    approvals: [
      { odId: '3', odname: 'Emily Davis', approved: true, approvedAt: '2025-12-14T16:30:00Z', comments: '' },
      { odId: '1', odname: 'Sarah Johnson', approved: true, approvedAt: '2025-12-14T17:00:00Z', comments: 'Approved' },
      { odId: '2', odname: 'Mike Chen', approved: true, approvedAt: '2025-12-14T17:15:00Z', comments: '' }
    ],
    createdAt: '2025-12-14',
    updatedAt: '2025-12-14'
  }
];

// Meeting Analytics Data
export const mockMeetingAnalytics = {
  totalMeetings: 5,
  byStatus: {
    draft: 1,
    scheduled: 1,
    'in-progress': 0,
    'pending-review': 1,
    approved: 1,
    completed: 1
  },
  byType: {
    board: 1,
    excomm: 1,
    ops: 1,
    fin: 1,
    hr: 1
  },
  averageDuration: 84,
  attendanceRate: 92,
  actionItemsGenerated: 9,
  actionItemsCompleted: 3,
  momApprovalRate: 100,
  upcomingThisWeek: 2,
  pendingApprovals: 1
};
